import twLocale from 'element-ui/lib/locale/lang/zh-TW'
const tw = {
    message: {
        'menu_title': '盛大金業',
        'menu_home': '首頁',
        'menu_about_us': '關於我們',
        'menu_plat_advant': '平台優勢',
        'menu_product_introduct': '產品介紹',
        'menu_latest_news': '最新資訊',
        'menu_open_account': '網上開戶',
        'menu_process_info': '流程資料',
        'menu_contact_us': '聯絡我們',
        'menu_second_nav_1': '公司簡介',
        'menu_second_nav_2': '公司獎項',
        'menu_second_nav_3': '公司資質',
        'menu_second_nav_4': '產品優勢',
        'menu_second_nav_5': '存取優勢',
        'menu_second_nav_6': '信譽優勢',
        // 'menu_second_nav_7': '會員系統',
        'menu_second_nav_8': '現貨黃金',
        'menu_second_nav_9': '現貨白銀',
        'menu_second_nav_10': '人民幣公斤條',
        'menu_second_nav_11': '交易細則',
        'menu_second_nav_13': '公司公告',
        'menu_second_nav_14': '經濟數據',
        'menu_second_nav_15': '每日匯率',
        'menu_second_nav_16': '經濟新聞',
        'menu_second_nav_17': '專業評論',
        'menu_second_nav_18': '公司活動',
        'menu_second_nav_19': '開立真實帳戶',
        'menu_second_nav_20': '開立真實帳戶流程',
        'menu_second_nav_22': '存款流程',
        'menu_second_nav_23': '在線取款流程',
        'menu_second_nav_24': '國內卡優惠',
        'menu_second_nav_25': '下載交易軟件',
        'menu_second_nav_28': '聯絡資料',
        'menu_second_nav_29': '即時開戶',
        'menu_second_nav_30': '在線客服',
        'menu_second_nav_31': '官方微信',
        'menu_second_nav_32': '軟件下載',
        'menu_online_transat': '線上交易',
        'menu_real_account': '開立真實帳戶',
        'menu_simulat_transat': '模擬交易',
        'menu_simulat_account': '開立模擬帳戶',
        'menu_dowan_trad_soft': '下載模擬交易軟件',
        'menu_simulat_href': 'https://dwebt.sdggex.com:21420/demo/regdemo_tc.asp',
    },
    brandInfo: {
        'brand_menu_title_1': '品牌優勢',
        'brand_menu_title_2': '開戶流程',
        'brand_title_1': '低門檻',
        'brand_title_2': '高槓桿',
        'brand_title_3': '雙向交易',
        'brand_title_4': '公平貨幣兌換',
        'brand_title_5': '交易平台迅速及穩定',
        'brand_title_6': '投資便捷',
        'brand_title_7': '24小時取款',
        'brand_title_8': '信心保證',
        'brand_title_9': '交易公平、公正、公開',
        'brand_title_10': '存款即時到帳',
        'brand_dec_text_1': '最低可交易0.1手，資金低',
        'brand_dec_text_2': '資金少，高槓桿，以小博大',
        'brand_dec_text_3': '黃金、白銀可做多或做空價格上漲可做多盈利',
        'brand_dec_text_4': '按照銀行公佈的貨幣兌換率',
        'brand_dec_text_5': '盛大交易平台穩定，交易迅速及易學易用',
        'brand_dec_text_6': '盛大交易平台24小時隨時交易',
        'brand_dec_text_7': '客戶可隨時透過完善的網上用戶中心提取',
        'brand_dec_text_8': '香港金銀貿易場會員',
        'brand_dec_text_9': '交易平台的所有訂單價格由國際市場價格，確保公平公正',
        'brand_dec_text_10': '24小時在線入金，即時入賬到盛大交易賬戶',
        'process_steps_title_1': '第1步：提交資料',
        'process_steps_title_2': '第2步：系統審核',
        'process_steps_title_3': '第3步：開戶通知',
        'process_steps_title_4': '第4步：軟件下載',
        'process_steps_title_5': '第5步：登入賬戶',
        'process_steps_title_6': '第6步：使用現有賬戶登入',
        'process_steps_dec_text_1': '點擊導航欄“網上開戶”或點擊右側快捷導航欄“即時開戶”提交申請資料',
        'process_steps_dec_text_2': '系統根據您所填寫的開戶資料進行自動審核，如審核失敗請及時聯繫客服',
        'process_steps_dec_text_3': '資料審核成功後，工作人員會在24小時內，向您的郵箱或電話發送賬戶及密碼',
        'process_steps_dec_text_4': '獲取您的賬戶及密碼後，點擊本官網下載頁面下載交易軟件並安裝',
        'process_steps_dec_text_5': '使用安裝的交易軟件及系統發送的賬戶密碼登入您的賬戶',
        'process_steps_dec_text_6': '登入選項選擇使用現有賬戶登入'
    },
    productInfo: {
        'product_title': '產品介紹',
        'product_dec_gold': '現貨黃金',
        'product_dec_silver': '現貨白银',
        'product_dec_rmb': '人民幣公斤條',
        'product_gold_title': '產品介紹：現貨黃金',
        'product_min_title_one': '現貨黃金的由來',
        'product_gold_dec_1': '<p>倫敦是歷史最悠久的黃金交易所，故現貨黃金的另一個名稱“倫敦金”亦由此而來現今主流的四個黃金交易中心包括國際黃金價格亦因以上四個交易中心而得以接軌，並提供24小時的黃金交易</p>',
        'product_min_title_two': '黃金的用途',
        'product_gold_dec_2': '<p>黃金自古以來已經被應用於貨幣、婚嫁飾物、國際儲備以及各類工業用途在投資層面，近年黃金已漸漸發展成為主流投資產品，不再只是以往的保值和避險作用</p>',
        'influence_gold_price_title': '影響黃金價格因素',
        'influence_price_title_one': '影響一：美元強弱',
        'influence_price_title_two': '影響二：通貨膨脹',
        'influence_price_title_three': '影響三：黃金需求',
        'influence_price_title_four': '影響四：各國政府政策',
        'influence_price_title_five': '影響五：突發事件（如戰爭）',
        'influence_gold_one_dec': '<p>美元跟黃金同為避險的其中一種工具，也能視為彼此間的競爭對手。</p><br/><p>資金往往會選擇較強勢的資產避險，當美元強勢的時候，資金會從各類資產（包括黃金）流入美元，相反則會流出。</p><br/><p>故此黃金價格會與美元的强弱形成一個反比情况，當然亦會出現少數正比的情况。</p>',
        'influence_gold_two_dec': '<p>由於黃金被視為保值以及避險的作用，不少投資者皆會以黃金作為對抗通脹的一種投資產品，所以通脹亦會令黃金的價格上升。</p>',
        'influence_gold_three_dec': '<p>按照經濟學的定義，當需求比供應更大時，就會帶動價格上升。</p><p>黃金的供應難於擴大（因為開採難度，以及金礦的出產量），面對日漸增大的黃金需求，黃金的價格亦會囙此而上升。</p>',
        'influence_gold_four_dec': '<p>近期各國政府皆推出各種貨幣量化寬鬆政策，貨幣亦囙此而貶值，故此令到資金尋求保值的投資產品。</p><p>使黃金成為其中一種受到追捧的投資產品。</p>',
        'influence_gold_five_dec': '<p>各種突發事件，如戰爭，地震等都有機會令到當地政局不穩或經濟受到影響，這會促使投資者買入黃金作避險。</p>',
        'product_silver_title': '產品介紹：白銀的用途',
        'product_silver_min_title_one': '白銀的用途',
        'product_silver_dec_1': '<p>白銀以往是僅次於黃金的一種貴金屬；</p><p>白銀是古時貨幣的其中一種；</p><p>隨著現今社會白銀的重要性越來越低,白銀已經不再視為貨幣金屬；</p><p>基於其特性,良好的導電和導熱,使白銀成為了工業金屬；</p><p>除了工業用途,白銀亦被應用於各種不同的產品裡,包括飾物,餐具,攝影器材及投資用途等等。</p>',
        'product_silver_influen_title': '影響白银價格因素',
        'product_silver_influen_one': '影響一：受到生產國每年生產的數量影響',
        'product_silver_influen_two': '影響二：通貨膨脹',
        'product_silver_invest_title': '白銀投資',
        'product_silver_invest_one': '高槓桿',
        'product_silver_invest_two': '靈活',
        'product_silver_invest_one_dec': '擁有比現貨黃金更高的槓桿比例',
        'product_silver_invest_two_dec': '24小時雙向交易讓客戶能把握每個財富增值時機',
        'rmb_kilo_title_one': '產品介紹：人民幣公斤條',
        'rmb_kilo_min_title_one': '甚麼是人民幣公斤條',
        'rmb_kilo_title_one_dec_1': '<p>由於香港的人民幣存款不斷增加。據香港金融管理局數據顯示人民幣存款已約佔香港總存款10%。但與此同時，離岸人民幣產品仍相當缺乏。</p><br><p>國務院副總理李克強在十二五規劃促進兩地金融經貿合作時，為了推進人民幣國際化進程，特批香港金銀業貿易場推出全球首個離岸市場、以人民幣計價黃金現貨交易產品--人民幣公斤條黃金。金銀業貿易場在新聞稿中表示，新產品可幫助推動人民幣國際化及香港人民幣離岸中心發展，為投資者提供更多人民幣投資產品選擇，也可鞏固香港作為世界主要黃金交易中心的地位。</p><br><p>人民幣公斤條黃金在香港金銀業貿易場設立及營運之自動對盤及交易系統內進行交易。金條規格與上海黃金交易所劃一，是貿易場認可煉鑄商生產的9999成色公斤條，可透過貿易場電子交易系統交易。</p>',
        'rmb_kilo_title_two': '影響人民幣公斤條價格因素',
        'rmb_kilo_title_two_dec_1': '<p>持倉成本影響人民幣公斤條黃金的定價，若沒有現貨市埸供求的因素，人民幣公斤條黃金的理論價等於買入相關現貨黃金的成本。而現貨市埸由實金供求為基礎，與金融市埸以資金拆借成本定借貸供求的模式有所不同。人民幣公斤條黃金的現貨交割機制是上板交割實金時，交割雙方在現貨市埸上套取現金為考慮因素之一，另有意建立中立倉套取息差的行員將有意欲參與實金交割，間接影響現貨市埸的供求。如倉費由持倉者支付予欠倉者，俗稱「低息」。相反，如倉費由持倉者收取或欠倉者支付，則為「高息」。</p>',
        'rmb_kilo_min_title_two_1': '現貨市場供求',
        'rmb_kilo_min_title_two_2': '持倉成本',
        'rmb_kilo_title_two_dec_2': '<p>人民幣公斤條黃金價格將受現貨市埸供求的變化所影響，再者，市埸情緒及參與行員亦是影響短期價格的因素，因此，人民幣公斤條黃金的市埸價格不一定與相關市埸價格相同。</p>',
        'rmb_kilo_title_three': '人民幣公斤條黃金特點',
        'rmb_kilo_title_three_min_title_one': '人民幣報價及以人民幣作合約結算',
        'rmb_kilo_title_three_min_title_one_dec1': '<p>民幣報價及以人民幣作合約結算，即實金交割清算。認可上海黃金交易所1號金(成色9999)或2號金(成色9995)及或貿易場認可黃金煉鑄商煉鑄之公斤條(成色9999)，為一公斤合約。投資者可透過貿易場的會員進行買賣。</p>',
        'rmb_kilo_title_three_min_title_two': '採用現行電子交易平臺提供人民幣公斤條黃金',
        'rmb_kilo_title_three_min_title_two_dec1': '<p>採用現行電子交易平臺提供人民幣公斤條黃金，只提供已參與電子交易平臺行員。所有透過貿易場電子交易平臺進行之合約買賣均獲貿易場派發獨有的[合約交易編碼]，以證明有關交易透過貿易場之電子交易平臺進行，投資者更可以憑藉有關[合約交易編碼]於貿易場網站查閱交易資料,大大提高投資黃金的透明度,以保障投資者的利益。</p>',
        'rmb_kilo_title_four': '投資盛大金葉人民幣公斤條黃金優勢',
        'rmb_kilo_title_four_min_title_one': '低門檻',
        'rmb_kilo_title_four_min_title_one_dec': '最低交易量0.5張合約,1,500人民幣即可進行交易(盛大金業每張合約需要3000人民幣保證金)',
        'rmb_kilo_title_four_min_title_two': '靈活',
        'rmb_kilo_title_four_min_title_two_dec': '24小時雙向交易讓客戶能把握每個財富增值時機',
        'transact_table_td_1': '本地現貨金(LLG)',
        'transact_table_td_2': '本地現貨白銀(LLS)',
        'transact_table_td_3': '合約單位(每手)',
        'transact_table_td_4': '100盎司',
        'transact_table_td_5': '5000盎司',
        'transact_table_td_6': '交易差價',
        'transact_table_td_7': '0.50美元/盎司',
        'transact_table_td_8': '0.05美元/盎司',
        'transact_table_td_9': '基本保證金',
        'transact_table_td_10': '每手2500美元',
        'transact_table_td_11': '單筆最低交易數量',
        'transact_table_td_12': '0.1手合約',
        'transact_table_td_13': '單筆最大交易數量',
        'transact_table_td_14': '10手合約',
        'transact_table_td_15': '手續費 (每手)',
        'transact_table_td_16': '50美元',
        'transact_table_td_17': '每日利息',
        'transact_table_td_18': '買入: -1.75%; 賣出: -1.25% (此處為年利率)，按市場決定',
        'transact_table_td_19': '每日倉租',
        'transact_table_td_20': '不適用',
        'transact_table_td_21': '鎖倉保證金',
        'transact_table_td_22': '625美元 (一套1250美元)',
        'transact_time_end_title': '交易時間及結算時間',
        'transact_time_table_td_1': '夏令',
        'transact_time_table_td_2': '冬令',
        'transact_time_table_td_3': '交易時間',
        'transact_time_table_td_4': '由星期一上午07:01至星期六凌晨03:59',
        'transact_time_table_td_5': '由星期一上午07:01至星期六凌晨03:59',
        'transact_time_table_td_6': '結算時間',
        'transact_time_table_td_7': '每日香港時間凌晨五時至六時正',
        'transact_time_table_td_8': '每日香港時間凌晨六時至七時正',
        'transact_time_table_td_9': '美國冬令時間由十一月第一個星期日早上二時至三月第二個星期日早上二時；',
        'transact_time_table_td_10': '美國夏令時間由三月第二個星期日早上二時至十一月第一個星期日早上二時。',
        'transact_time_table_td_11': '交易時將會按國際假期更改,如有更動將會於本公司網頁公佈',
        'transact_time_table_td_12': '持倉過巿星期五,六,日,需付三天利息',
        'transact_mode_max_title': '交易方式',
        'transact_mode_title_one': '市價單',
        'transact_mode_title_two': '限價單',
        'transact_mode_title_three': '止盈單及止損單',
        'transact_mode_one_dec_1': '以當時巿場價格進行交易,如遇上巿況波動,巿價單有可能不會成交',
        'transact_mode_two_dec_1': '現貨黃金限價單需要與巿場價格相距最少300個價位(即3美元)或以上才能設定, 現貨白銀限價單需要與巿場價格相距最少30個價位(即0.3美元)或以上才能設定',
        'transact_mode_two_dec_2': '* 若客戶交易帳號內的保證金不足提交限價單不會成交, 並會即時取消處理',
        'transact_mode_three_dec_1': '可為仍未平倉的合約設定, 現貨黃金需要300個價位以上才能設定,現貨白銀需要價格30個價位以上才能設定',
        'transact_mode_three_dec_2': '* 所有限價單,止盈單,止損單有效時間直至當週收巿時間或假期收巿前, 除非已成交或客戶自行取消',
        'transact_force_title_one': '強制平倉',
        'transact_force_title_two': '異常交易',
        'transact_force_title_three': '跳空規則',
        'transact_force_title_one_dec': '<p>當交易帳號內的淨值低於保證金50%或以下，客戶將被要求追加預付款至基本預付款比例。當交易帳號內的淨值低於保證金要求的20%或以下, 為保障客戶利益, 本公司將會為客戶持单部分合约或全部合约平仓, 直至淨值回到保證金要求的20%以上</p>',
        'transact_force_title_two_dec': '<p>1、如因網路延遲,故障,電腦故障,報價誤差或報價系統漏洞, 均有可能造成交易平臺上的報價無法準確地反映即時巿場價格, 為維護網絡交易的公平性,盛大金業并不接受任何利用故障或漏洞進行之交易,如經發現會將所有有關交易取消并追回, 所有非法利潤及其所產生的額外費用</p><p>2、如當中有30%的訂單持倉時間低於3分鐘，或屬於3分鐘內建立的鎖倉訂單，賬戶會被判定為交易異常</p><p>★ 交易單虧損額達到交易本金10%或以上，不作任何處理，將客戶的取款金額發放給客戶并會銷戶處理</p><p>★ 交易單虧損額低於交易本金10%，我們會收取注資金額的10%作爲異常交易産生的成本費用，再將余額發放給客戶并會銷戶處理。</p><p>★ 審核周期內的交易單是盈利的，我們會扣除所有盈利并會收取注資金額的10%作爲異常交易産生的成本費用，再將余額發放給客戶并會銷戶處理。</p>',
        'transact_force_title_three_dec': '<p>在一般跳空情況下, 所有限價單將根據客戶所訂立的價格成交, 如遇上客戶同時存在未平倉合約及限價單, 跳空導致保證金不足, 持有倉位會被斬倉及限價單被取消, 盛大金業保留對客戶的以上情況的最終審批權</p>'


    },
    platformAdvant: {
        'product_advant_title_one': '優勢一：低門檻',
        'product_advant_title_two': '優勢二：雙向交易',
        'product_advant_title_three': '優勢三：高槓桿',
        'product_advant_title_four': '優勢四：投資便捷',
        'product_advant_one_dec': '最低可交易0.1手，資金低，為更廣泛的投資者創造了小資金、低門檻的入門機會。',
        'product_advant_two_dec': '交易現貨黃金和現貨白銀可做多或做空，黃金價格或白銀價格上漲可做多盈利，相反下跌則可做空盈利，無論昇市或跌市均有投資獲利機會。',
        'product_advant_three_dec': '投入資金少，高槓桿，高回報。倫敦金交易實行保證金制度，金價每波動1美元，一手就有100美元的收益，以小博大，更有效的利用資金，放大投資回報率。',
        'product_advant_four_dec': 'MF4交易平臺24小時隨時交易。倫敦、紐約、香港等全球黃金市場交易時間連成一體，構成一個24小時無間斷的投資交易系統，客戶通過MF4電子交易系統進行24小時交易。',
        'access_advant_title_one': '優勢一：存款即時到帳',
        'access_advant_title_two': '優勢二：24小時取款',
        'access_advant_title_three': '優勢三：公平貨幣兌換',
        'access_advant_one_dec': '銀聯24小時線上入金，即時入帳到MF4交易帳戶，方便客戶在波動的市場作出即時的資金調配，捕捉每一個獲利機會或避免損失。',
        'access_advant_two_dec': '客戶可隨時透過完善的網上用戶中心，提取帳戶內的資金，方便客戶靈活調配資金。',
        'access_advant_three_dec': '按照銀行公佈的貨幣兌換匯率，並在官網發報最新匯率，提高兌換透明度，保證貨幣兌換公平，公正，清晰。',
        'reput_advant_title_one': '優勢一：信心保證',
        'reput_advant_title_two': '優勢二：交易公平、公正、公開',
        'reput_advant_title_three': '優勢三：交易平台迅速及穩定',
        'reput_advant_one_dec': '盛大金業是香港金銀業貿易場會員第162號行員，是香港金銀業貿易場認可實金買賣商及提供電子交易商。',
        'reput_advant_two_dec': '下單價格均按國際黃金市場為准，確保交易公平、公正、公開',
        'reput_advant_three_dec': '盛大金業現正使用多年來廣授國際品牌移動財經(MF4)交易軟件，主要是因為MF4交易平臺穩定，交易迅速及易學易用，確保客戶交易簡便、迅速及穩定。'
        
    },
    platDownload: {
        'trand_platform_title': '盛大交易平臺',
        'trand_plat_dec': '電腦端軟件在線下載',
        'download_dec_one': '點擊此處下載',
        'download_dec_one_1': '點擊下載Windows版',
        'download_dec_two': '備用下載地址',
        'download_dec_text': '若以上通道無法下載，可選擇以下備用通道',
        'download_iphone_text': 'iphone版掃碼下載',
        'download_android_text': 'Android版掃碼下載'
    },
    aboutIntroduct: {
        'introduct_title': '盛大金業簡介',
        'introduct_dec_content': '香港盛大金業有限公司，為香港金銀業貿易場第162號行員，屬於香港金銀業貿易場認可實金買賣商。盛大金業並提供24小時倫敦金、銀網絡交易，各種專業、快捷、準確資訊。為客戶提供專業服務團隊，24小時客服解答客戶交易問題。致力提供穩定、公平、公正的交易平臺。專業優秀服務團隊以客為本，務求滿足客戶的投資需求。成為業界內其中一間最優秀的黃金投資企業，樹立良好形象，獲取廣大客戶愛護及信任。',
        'introduct_charact_1': '核心技術',
        'introduct_charact_2': '金融服務',
        'introduct_charact_3': '專業機构',
        'introduct_charact_4': '全球交易者'
    },
    processInfo: {
        'domestic_car_title': '國內卡存款',
        'domestic_car_proces_one': '在盛大金業網站登錄',
        'domestic_car_proces_two': '於網站內的入金信息選擇國內卡存款',
        'domestic_car_proces_three': '用國內卡存款並”需要”提交單據截圖',
        'domestic_car_proces_four': '使用國內卡存款方法將會豁免銀聯存款手續費',
        'deposit_car_title': '香港銀行卡存款/電匯',
        'deposit_car_proces_one': '存款到盛大金業香港銀行戶口',
        'deposit_car_proces_two': '存款完成後，單據截圖請以電郵/傳真/QQ等管道提交到盛大金業客戶服務部',
        'deposit_car_proces_three': '假若客戶是以電匯形式進行存款，存款時間會因應各地銀行而有所不同',
        'deposit_car_proces_four': '確認資金到帳後，資金將會立即存到交易帳戶，客戶可即時進行交易',
        'bank_info_title': '存款銀行資料',
        'company_name_title': '公司名稱',
        'company_name_info': '盛大金業有限公司',
        'company_address_title': '公司地址',
        'company_address_info': '香港銅鑼灣時代廣場一座45樓',
        'bank_address_title': '銀行地址',
        'bank_address_info': '香港中環皇后大道中161號',
        'bank_name_info': '銀行名稱',
        'bank_title_account_info': '帳戶名稱',
        'bank_account_info': '銀行帳號',
        'bank_swift_code_info': '國際匯款代碼',
        // 'bank_address_info': '銀行地址',
        'bank_name_info_1': '華僑永亨銀行',
        'bank_title_account_info_1': '盛大金業有限公司',
        // 'bank_address_info_1': '永亨網上轉帳 - Maker 程俊彥 / Authorizer 林霆鋒',
        'online_process_title_one': '親身辦理',
        'online_process_title_two': '網上提交出金申請',
        'online_process_title_three': '郵寄/電郵/QQ',
        'online_process_title_one_dec': '客戶可以在盛大金業辦公時間內親臨本公司提交出金申請',
        'online_process_title_two_dec': '客戶只需使用盛大金業所提供的網上帳號及密碼登陸盛大金業網站, 即可透過網站提交出金申請, 本公司在核實資料無誤後,保證資金1小時內到賬',
        'online_process_title_three_dec': '客戶可以將已簽署及填寫出金金額的申請表, 以郵寄/電郵/QQ形式提交到盛大金業',
        'online_process_precaution_title': '注意事項：',
        'online_process_precaution_dec_1': '<p>1、盛大金業只接受客戶本人之名義存款及提取資金, 不接受第三方入金以及提款至第三方帳戶</p><br><p>2、為客戶能盡早提取資金, 請核實閣下的銀行帳戶資料是否正確無誤</p><br><p>3、每個工作日遞交提取資金申請的截止時間為下午4時30分, 逾時之申請將會在下一個工作天處理</p><br><p>4、客戶申請取款，收款銀行可能收取轉賬所需之行政費，一切手續費均會從提款中扣除</p><br><p>5、客戶申請取款後, 若發現有任何問題請盡快聯絡客服部門查詢</p><br><p>6、盛大金業將有以下措施防範不法份子:</p><p>客戶帳號出金金額中有50%不曾用於建倉交易或最後一次存款後未有進行建倉交易, 取款時將被收取6%手續費。客戶完成入金後, 申請出金金額時達到以下交易手數可免除出金手續費:</p>',
        'domestice_card_title': '現貨黃金/白銀/人民幣公斤條',
        'domestice_card_dec_1': '為回饋盛大金業客戶, 盛大金業將由2021年4月1日起, 豁免銀聯存款手續費。 客戶帳號舊有的信用額則按照原有的規則回贈。',
        'domestice_terms_title': '條款及細則：',
        'domestice_terms_dec_1': '<p>1、只適用於透過國內銀行卡注入的資金</p><br><p>2、盛大金業有權利隨時修改或終止此優惠活動</p><br><p>3、如有任何爭議, 盛大金業擁有最終決定權</p>'
    },
    contactUsInfo: {
        'contact_company_max_title': '香港盛大金業有限公司',
        'contact_business_title': '商務拓展部',
        'contact_business_email': 'cs@sdggex.com (3个工作日内回复)',
        'contact_business_qq': '852-37011110 (9:30-18:30)',
        'contact_business_address': '香港銅鑼灣時代廣場一座45樓',
        'contact_market_title': '市場品牌部',
        'contact_market_email': '商务部 cs@sdggex.com (3个工作日内回复)',
        'contact_market_qq': '852-37011117 (9:30-18:30)',
        'contact_market_address': '香港銅鑼灣時代廣場一座45樓',
        'contact_customer_title': '客服',
        'contact_customer_email': 'cs@sdggex.com (3个工作日内回复)',
        'contact_customer_qq': '852-37011117 (9:30-18:30)',
        'contact_customer_address': '香港銅鑼灣時代廣場一座45樓',
        'contact_compay_address': '香港銅鑼灣時代廣場一座45樓'
    },
    accountInfo: {
        account_min_title: '24小時開戶/立即開啟投資之旅',
        account_name_info: '真實姓名',
        account_identity_card: '身份證號碼',
        account_sex: '性別',
        account_sex_1: '男',
        account_sex_2: '女',
        account_phone_number: '手機號碼',
        account_phone_area: '手機區號',
        account_card_front: '身份證副本（正面）',
        account_upload_file: '上傳文件',
        account_card_hold: '手持身份證照片',
        account_photo_text: '（身份證放在白紙上方，白紙上寫上僅供盛大金業開戶使用，並寫上開戶當天的日期，例如：2018年1月1日。選擇上傳文件大小在3M內，上傳檔案格式為：JPG/PNG）',
        account_email: '電子郵箱',
        account_bank_number: '銀行卡號',
        account_bank_deposit: '開戶銀行',
        account_bank_branch: '支行',
        account_bank_copy: '銀行卡副本（正面）',
        account_referen_number: '介紹人編號',
        accout_verif_method: '驗證方式',
        account_eamil_verficat: '電子郵箱驗證',
        account_graphic_code: '圖形驗證碼',
        account_open_verfit_code: "開戶驗證碼",
        account_agreement_text_1: '我已閱讀並同意',
        account_agreement_text_2: '【隱私條款】',
        account_agreement_text_3: '【免責聲明】',
        account_agreement_text_4: '【風險聲明】',
        account_agreement_text_5: '【客戶協議】',
        account_submit_btn_info: '立即提交'
    },
    verificationInfo: {
        verificat_rule_upload: '未上傳',
        rule_get_verifit_code: '獲取驗證碼',
        rule_attachment_upload: '已上傳附件',
        rule_read_text: '請勾選已閱讀並同意協定',
        rule_loading_text: '正在加載...',
        rule_audit_success: '提交成功，工作人員將會在1~2個工作日內稽核。',
        rule_verificat_name: '請輸入真實姓名',
        rule_verificat_card_no: '請輸入身份證號碼',
        rule_verificat_phone_number: '請輸入手機號碼',
        rule_verificat_email: '請輸入電子郵箱',
        rule_bank_card_number: '請輸入銀行卡號',
        rule_bank_address: '請輸入開戶銀行地址',
        rule_bank_branch_name: '請輸入開戶銀行支行名字',
        rule_reference_number: '請輸入介紹人編號',
        rule_account_open_code: '請輸入開戶驗證碼',
        rule_graphic_code: '請輸入圖形驗證碼',
        rule_upload_card: '請上傳身份證副本（正面）',
        rule_upload_hold_card: '請上傳手持身份證照片',
        rule_upload_bank_card: '請上傳銀行卡副本（正面）',
        rule_graphic_code_empty: '圖形驗證碼不能為空，請輸入圖形驗證碼',
        rule_email_empty: '郵箱不能為空，請輸入郵箱！',
        rule_area_empty: '手機區號不能為空，請選擇手機區號！',
        rule_phone_empty: '手機號碼不能為空，請輸入手機號碼！',
        rule_tips_text: '提示',
        rule_sure_btn: '確定'
    },
    moreInfo: {
        'more_info': '瞭解更多'
    },
    agreementFile: {
        'privacy_clause_file': '/static/agreementFile/tw/隱私條款.pdf', // 隐私条款协议
        'disclaimer_file': '/static/agreementFile//tw/免責聲明.pdf', // 免责申明协议
        'risk_statement_file': '/static/agreementFile/tw/風險聲明.pdf', // 风险申明协议
        'customer_agreement_file': '/static/agreementFile/tw/客戶協議.pdf' // 客户协议
    },
    ...twLocale
}

export default tw